import configuration from "./../config.json";
import reportService from "../shared/services/reportService";
import CookieService from "./../shared/services/cookiesService";
import { downloadFile } from "./../shared/services/download.service";
import { setLogout } from "./authActions";

const REQUEST_DOWNLOAD_REPORTS = "REQUEST_DOWNLOAD_REPORTS";
const REQUEST_DOWNLOAD_REPORT = "REQUEST_DOWNLOAD_REPORT";
const RESPONSE_DOWNLOAD_REPORT = "RESPONSE_DOWNLOAD_REPORT";
const REQUEST_DOWNLOAD_REPORT_FAILURE = "REQUEST_DOWNLOAD_REPORT_FAILURE";
const CLEAR_DOWNLOAD_REPORTS = "CLEAR_DOWNLOAD_REPORTS";

const requestDownloadReportsAction = (report, selectedCars, format) => {
  return {
    type: REQUEST_DOWNLOAD_REPORTS,
    payload: { report, selectedCars, format },
  };
};

const setRequestDownloadReports = (report, selectedCars, format = { title: "xlsx" }) => {
  return (dispatch) => {
    dispatch(requestDownloadReportsAction(report, selectedCars, format));
  };
};

const requestDownloadReportAction = (reportId, carId) => {
  return {
    type: REQUEST_DOWNLOAD_REPORT,
    payload: { reportId, carId },
  };
};

const responseDownloadReportAction = (reportId, carId) => {
  return {
    type: RESPONSE_DOWNLOAD_REPORT,
    payload: { reportId, carId },
  };
};

const requestDownloadReportFailureAction = (reportId, carId, errors) => {
  return {
    type: REQUEST_DOWNLOAD_REPORT_FAILURE,
    payload: { reportId, carId, errors },
  };
};

const downloadReport = (report, car, format = { title: "xlsx" }, options) => {
  return (dispatch) => {
    dispatch(requestDownloadReportAction(report.id, car.id));

    let requestOptions = {
      units: [car.id],
      startDate: options.startDate,
      endDate: options.endDate,
      timeZone: options.timeZone,
      format: format.id,
    };

    reportService
      .downloadReport(report.id, requestOptions)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12);
        downloadFile(result.data, report, car, format, options);
        dispatch(responseDownloadReportAction(report.id, car.id));
      })
      .catch((error) => {
        dispatch(requestDownloadReportFailureAction(report.id, car.id, error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearDownloadReportsAction = () => {
  return {
    type: CLEAR_DOWNLOAD_REPORTS,
  };
};

const clearDownloadReports = () => {
  return (dispatch) => {
    dispatch(clearDownloadReportsAction());
  };
};

export {
  setRequestDownloadReports,
  requestDownloadReportsAction,
  downloadReport,
  requestDownloadReportAction,
  responseDownloadReportAction,
  requestDownloadReportFailureAction,
  clearDownloadReports,
  clearDownloadReportsAction,
  REQUEST_DOWNLOAD_REPORTS,
  REQUEST_DOWNLOAD_REPORT,
  RESPONSE_DOWNLOAD_REPORT,
  REQUEST_DOWNLOAD_REPORT_FAILURE,
  CLEAR_DOWNLOAD_REPORTS,
};
